import CoreLayout from '../layouts/PageLayout/PageLayout'
import UserLayout from '../layouts/UserLayout/UserLayout'
import PublicLayout from '../layouts/PublicLayout/PublicLayout'
import PrivateVerificationLayout from '../layouts/PrivateVerificationLayout/PrivateVerificationLayout'
import SignupLayout from '../layouts/SignupLayout/SignupLayout'
import HomeRoute from './home'
import IndexHtmlRoute from './indexHtml'
import SignupRoute from './signup'
import LogoutRoute from './logout'
import SupportRoute from './support'
import CandidatesRoute from './candidates'
import RequestEditRoute from './requestEdit'
import OpinionRoute from './opinion'
import PaymentsRoute from './payments'
import AccountConfirmationRoute from './accountConfirmation'
import AccountConfirmationUidBlankRoute from './accountConfirmation/blankUid'
import EmailConfirmationRoute from './emailConfirmation'
import RequestConfirmationRoute from './requestConfirmation'
import LoginRoute from './login'
import ResetPassword from './resetPassword'
import AuthenticationCodeConfirmationRoute from './authenticationCodeConfirmation'

export default [
  {
    layout: PublicLayout,
    routes: [
      HomeRoute,
      LoginRoute,
      IndexHtmlRoute,
      ResetPassword,
    ]
  },
  {
    layout: CoreLayout,
    routes: [
      LogoutRoute,
      AccountConfirmationRoute,
      AccountConfirmationUidBlankRoute,
      RequestConfirmationRoute,
      AuthenticationCodeConfirmationRoute,
      EmailConfirmationRoute,
    ]
  },
  {
    layout: SignupLayout,
    routes: [
      SignupRoute
    ]
  },
  {
    layout: PrivateVerificationLayout,
    routes: [
      RequestEditRoute,
      OpinionRoute,
      PaymentsRoute,
    ]
  },
  {
    layout: UserLayout,
    routes: [
      CandidatesRoute,
      SupportRoute,
    ]
  },
]



// WEBPACK FOOTER //
// ./src/routes/index.js